<template>
  <Head>
    <title>Products | NutriStudents K-12</title>
    <meta name="description" content="Products">
  </Head>
  <default-layout>
    <BreadcrumLayout>
      <!-- <a href="#" class="link-color"> --><U>Templates</U><!-- </a> -->
    </BreadcrumLayout>
    <PageTitleLayout>
      <div class="lg:mb-0 mb-4">
        <h1 class="heading-color xl:text-4xl text-2xl font-bold">Products</h1>
      </div>
      <div class="w-full flex lg:flex-nowrap flex-wrap justify-end items-center">
        <a :href="route('download-exception-report', 'products') + '?user=' + menuUserFilterVal + '&category=' + categoryval + '&subcategory=' + subcategoryval + '&search=' + search"
          title="Exception Product Report" class="flex items-center icon-color mr-3" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
            class="w-8 h-8">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
          </svg></a>

        <a href="javascript:void(0)" @click="clearFilter" class="flex items-center "><img
            :src="$page.props.asset_url + '/images/clear-filter.png'" class="max-h-6"></a>
        <div class="relative lg:pl-6 sm:pl-6 pl-0 lg:w-48 sm:w-1/2 w-full lg:top-0 sm:top-0 top-4 mr-5">
          <!-- <select id="menuUserFilter" name="menuUserFilter" autocomplete=""
            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
            @change="allFilter" v-model="menuUserFilterVal">
            <option value="">Source</option>
            <option v-for="menu_user in tenant_names" :value="menu_user['id']">{{ menu_user['name'] }}</option>
          </select> -->

          <div class="relative w-auto" v-click-outside="onClickOutside">
              <div class="relative inline-block w-full sm:text-sm normal-case">
                  <button 
                  v-on:click="showSourceDropDwon = !showSourceDropDwon"
                      type="button"
                      class="bg-white border border-gray-300 h-[38px] w-full text-left rounded-lg pr-10 pl-3"
                  >
                  Source
                  </button>
                  <ul v-if="showSourceDropDwon"
                      class="dropdown-menu min-w-[200px] absolute z-10 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-[250px] overflow-auto">
                      <li v-for="menu_user in tenant_names" :key="menu_user.id" class="px-4 py-2 hover:bg-gray-100 list_bg">
                          <label :for="menu_user.id" class="flex items-center cursor-pointer">
                              <input v-on:click=""
                              :value="menu_user.id"
                              :id="menu_user.id"
                              @change="allFilter"
                              v-model="menuUserFilterVal"
                              type="checkbox"
                              class="text-blue-600 focus:outline-none focus:ring-0 focus:shadow-none form-checkbox parent-checkbox"
                              data-group=""
                              />
                              <span class="ml-2">{{ menu_user.name }}</span>
                          </label>
                      </li>
                  </ul>
              </div>
          </div>
          <div
            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>
        <div class="relative focus:outline-none lg:w-44 sm:w-1/2 w-full">
          <select id="category" name="category" autocomplete="category"
            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
            @change="onChangeCategoryfunc" v-model="categoryval">
            <option value="">Category</option>
            <option v-for="category in categories" :value="category.id">{{ category.name }}</option>
          </select>
          <div
            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>
        <div class="relative lg:pl-6 sm:pl-6 pl-0 lg:w-48 sm:w-1/2 w-full lg:top-0 sm:top-0 top-4">
          <select id="sub_category" name="sub_category" autocomplete="sub_category"
            class="shadow-sm focus:border-color block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height"
            @change="onChangeSubCategoryfunc" v-model="subcategoryval">
            <option v-for="subcategory in subcategories" :value="subcategory.id">{{ subcategory.name }}</option>
          </select>
          <div
            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>
        <button>
          <inertia-link :href="route('products_add')"
            class="button-color text-white font-bold py-3 xl:px-4 px-2 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-4 mt-10  inline-block">
            CREATE NEW PRODUCT
          </inertia-link>
        </button>
      </div>
    </PageTitleLayout>
    <TableFilterLayout @messageFromChild="productSearchData" :isReport="true" :searchVal="prod_searched"
      @openReport="openReport" />
    <TableIndexLayout>
      <div class="-my-2">
        <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full">
          <div class="shadow overflow-x-auto max-height-screen">
            <table class="min-w-full">
              <thead class="header-bg-color">
                <tr>

                  <th scope="col"
                    class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider ">

                    <span v-if="orderBY == 'name' && orderType == 'desc'"
                      @click="orderBY = 'name'; orderType = 'asc'; allFilter();"
                      class="flex gap-2 items-center cursor-pointer">
                      PRODUCT NAME <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor" class="w-4 h-4 ">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18" />
                      </svg></span>
                    <span v-if="orderBY == 'name' && orderType == 'asc'"
                      @click="orderBY = 'name'; orderType = 'desc'; allFilter();"
                      class="flex gap-2 items-center cursor-pointer">PRODUCT NAME<svg xmlns="http://www.w3.org/2000/svg"
                        fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" />
                      </svg></span>

                    <span v-if="orderBY != 'name'" @click="orderBY = 'name'; orderType = 'desc'; allFilter();"
                      class="flex gap-2 items-center cursor-pointer">PRODUCT NAME <svg xmlns="http://www.w3.org/2000/svg"
                        fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5" />
                      </svg>
                    </span>

                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                    Source
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                    MANUFACTURER
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">

                    <span v-if="(orderBY == 'cn_code' && orderType == 'asc')"
                      @click="orderBY = 'cn_code'; orderType = 'desc'; allFilter();"
                      class="flex gap-2 items-center cursor-pointer">
                      CN# <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" />
                      </svg></span>
                    <span v-if="(orderBY == 'cn_code' && orderType == 'desc')"
                      @click="orderBY = 'cn_code'; orderType = 'asc'; allFilter();"
                      class="flex gap-2 items-center cursor-pointer">CN# <svg xmlns="http://www.w3.org/2000/svg"
                        fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 ">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18" />
                      </svg></span>

                    <span v-if="orderBY != 'cn_code'" @click="orderBY = 'cn_code'; orderType = 'asc'; allFilter();"
                      class="flex gap-2 items-center cursor-pointer">CN# <svg xmlns="http://www.w3.org/2000/svg"
                        fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5" />
                      </svg>
                    </span>


                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                    MFG#
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                    CATEGORY
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                    SUB CATEGORY
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                  </th>
                </tr>
              </thead>
              <tbody>

                <!-- Odd row -->
                <tr v-if="!products.data.length" class="bg-white">
                  <td class="px-6 py-4 whitespace-nowrap text-base text-color text-center" colspan="7">No Products Found
                  </td>
                </tr>

                <tr v-for="(product, index) in products.data"
                  :class="{ 'bg-white': index % 2 == 0, 'tr-background-color': index % 2 != 0 }">

                  <td
                    class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color underline id-color font-bold ">
                    <div class="flex items-center gap-x-2">
                      <div class="tooltip deprecated_block">
                        <!-- <img :src="$page.props.asset_url + '/images/deprecated.png'" alt="" v-if="product.deprecated_at" class="w-4 h-4 max-w-none cursor-default"> -->
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                          stroke="currentColor" v-if="product.discontinued_at"
                          class="w-6 h-6 max-w-none cursor-default text-black">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                        <div class="top deprecated_text">
                          <div class="flex items-center gap-3">
                            <span>Discontinued : product will be removed within 12 months.</span>
                          </div>
                        </div>
                      </div>
                      <div class="tooltip">
                        <div class="trim_text underline flex items-center gap-4">
                          <a :href="route('products_edit', { id: product.id })">{{ product.name }}</a>
                        </div>
                        <div class="top">
                          <div class="flex items-center gap-3">
                            <span>{{ product.name }}</span>
                            <!-- <img :src="$page.props.asset_url + '/images/deprecated.png'" alt="" class="w-4 h-4" v-if="product.deprecated_at"> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                    {{ product.tenant_name }}
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                    {{ product.manufacturer }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                    {{ product.cn_code }}
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                    {{ product.manufacturer_sku }}
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                    {{ product.category_name[0] }}
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                    {{ product.sub_category_name[0] }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap id-color text-xl font-extrabold">
                    <button type="button" @click="product_copy_save_script(product.id)" class="">
                      <i class="fa fa-clone pr-3" aria-hidden="true"></i>
                    </button>

                    <inertia-link :href="route('products_edit', { id: product.id })" class="">
                      <i class="fa fa-pencil-square-o pr-3" aria-hidden="true"></i>
                    </inertia-link>

                    <button v-if="product.is_tenant_admin" type="button" @click="product_delete_script(product.id)"
                      class="">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>

                  </td>
                </tr>


              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="float-left w-full flex justify-start px-10">
        <paginate :urlsArray="links"></paginate>
      </div>

      <div class="mt-12 flex justify-end pr-10 w-full mb-8">
        <button>
          <inertia-link :href="route('products_add')"
            class="button-color text-white font-bold py-1.5 px-4 mb- rounded focus:outline-none  inline-block">
            CREATE NEW PRODUCT
          </inertia-link>
        </button>
      </div>
    </TableIndexLayout>

    <jet-dialog-modal :show="isPopup">
      <template #title>
        <div class="flex justify-between items-center">
          <h2 class="sm:pt-4 pt-2 lg:text-2xl sm:text-lg text-sm">
            Generate Report
          </h2>
          <jet-secondary-button @click="closeModel" class="cursor-pointer pt-4">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </jet-secondary-button>
        </div>
        <div class="flex flex-wrap justify-between items-center float-right">

        </div>
      </template>

      <template #content>
        <label class="block font-semibold mb-1 text-left">Generate a report with 100 items</label>
        <div class="relative focus:outline-none w-full mr-3 xl:mt-0">
          <select v-model="report_type" v-on:change="min_range = ''; max_range = '';"
            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height">
            <option value="all">Generate Report for all 100 items</option>
            <option value="alpha">Generate Partial Report by Alpha Range</option>
            <option value="page">Generate Partial Report by Page Range</option>
            <option value="cn">Generate Partial Report by CN Range</option>
          </select>
          <div
            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>

        <div class="mt-4" v-if="report_type != '' && report_type != 'all'">
          <label v-if="report_type == 'alpha'" class="block font-semibold mb-1 text-left">Product Names</label>
          <label v-if="report_type == 'page'" class="block font-semibold mb-1 text-left">Page Range</label>
          <label v-if="report_type == 'cn'" class="block font-semibold mb-1 text-left">CN Range</label>
          <div class="flex gap-2 items-center">
            <input v-model="min_range" class="border-gray-300 rounded-lg w-full" type="text">
            to
            <input v-model="max_range" class="border-gray-300 rounded-lg w-full" type="text">
          </div>
        </div>

      </template>

      <template #footer>
        <a class="button-color text-white font-bold py-1 pb-1.5 rounded px-4 md:mt-0 mt-4 whitespace-nowrap inline-block max-w-max"
          :href="route('download-product-composition-report', {
            report_type: report_type, min_range: min_range, max_range: max_range, user: this.menuUserFilterVal, category: this.categoryval, subcategory: this.subcategoryval,
            search: this.search,
            orderBY: this.orderBY,
            orderType: this.orderType
          })">Generate</a>
      </template>
    </jet-dialog-modal>
  </default-layout>
</template>
<script>
import vClickOutside from "click-outside-vue3";
import DefaultLayout from "@/Layouts/DefaultLayout";
import Welcome from "@/Jetstream/Welcome";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import Paginate from "@/Pages/Partials/Paginate";
import JetDialogModal from "@/Jetstream/DialogModal";


export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: ['product_data', 'categories', 'prod_searched', 'prod_filter', 'prod_subfilter', 'menu_users', 'tenant_names', 'source', 'subcategory_val', 'orderType1', 'orderBY1'],
  components: {
    vClickOutside,
    DefaultLayout,
    Welcome,
    BreadcrumLayout,
    PageTitleLayout,
    TableFilterLayout,
    TableIndexLayout,
    Paginate,
    JetDialogModal
  },


  data() {
    return {
      isPopup: false,
      categoryval: this.prod_filter,
      subcategoryval: this.prod_subfilter,
      subcategories: this.subcategory_val,
      products: this.product_data,
      links: this.product_data.links,
      menu_users: this.menu_users,
      menuUserFilterVal: this.source  || [],
      search: '',
      orderBY: this.orderBY1,
      orderType: this.orderType1,
      report_type: 'all',
      min_range: '',
      max_range: '',
      showSourceDropDwon:false,
      form: this.$inertia.form({

      })
    }
  },


  methods: {
    onChangeCategoryfunc() {
      this.subcategoryval = '';
      if (this.categoryval == "") {
        this.allFilter();

      } else {

        axios.post('/get_prod_subcategories', { category_id: this.categoryval })
          .then((response) => {
            this.subcategories = [];
            this.subcategories = response.data;
          })
          .catch(error => console.error(error));
        this.allFilter();
      }
    },

    onChangeSubCategoryfunc() {
      this.allFilter();
    },

    product_copy_save_script(pid) {
      if (confirm("Are you sure you want to duplicate this product?")) {
        this.form.post(this.route('product_copy', pid), {
          onSuccess: () => {
            this.$toast.success('Product copied successfully!');
            // setTimeout(function(){
            //   window.location.reload();
            // }, 1000);
          }
        });
      }
    },

    product_delete_script(pid) {
      if (confirm("Are you sure you want to delete this product?")) {
        this.form.post(this.route('product_delete', pid), {
          onSuccess: () => {
            this.$toast.success('Product deleted successfully!');
            setTimeout(function () {
              window.location.reload();
            }, 1000);
          }
        });
      }
    },

    productSearchData(search) {
      this.search = search;
      this.allFilter();
    },
    openReport() {
      this.isPopup = true;
    },

    allFilter() {
      let $this = this;
      console.log("allFilter", this.menuUserFilterVal);
      this.hideShowLoader("show");
      // if(this.menuUserFilterVal){
      axios.post('/product-search-filter', {
        user: this.menuUserFilterVal,
        category: this.categoryval,
        subcategory: this.subcategoryval,
        search: this.search,
        orderBY: this.orderBY,
        orderType: this.orderType,
        routeName: this.$page.props.route_info_name
      })
        .then((response) => {
          this.hideShowLoader("hide");
          this.products = response.data;
          this.links = this.products.links;
          this.links.map(function (item, i) {
            if (item.url) {
              let new_url = item.url.split('?');
              let main_url = window.location.href.split('?')[0];
              item.url = main_url + '?' + new_url[1];
              return item;
            }
          });
        })
        .catch(error => {
          console.error(error);
          this.hideShowLoader("hide");
        });
      // }
    },
    clearFilter() {
      this.menuUserFilterVal = [];
      this.categoryval = '';
      this.subcategoryval = '';
      this.search = '';
      this.allFilter();
    },
    hideShowLoader(types) {
      if (types == "show") {
        document.getElementById("full_loader").style.display = "flex";
      } else {
        document.getElementById("full_loader").style.display = "none";
      }
    },
    closeModel() {
      this.isPopup = false;
      this.report_type = 'all';
      this.min_range = '';
      this.max_range = '';
    },
    onClickOutside(event) {
      this.showSourceDropDwon = false;
    },

  },

};


</script>


<style>
@media screen and (min-width: 1500px) {
  .id_arrow .fa-sort-desc:before {
    content: "\f0dd";
    position: absolute;
    top: 16px;
    left: 43px;
    padding-left: 7px;
    color: #219FD5;
  }

  .id_arrow .fa-sort-asc:before {
    content: "\f0de";
    color: #219FD5;
    padding-left: 7px;
    position: absolute;
    top: 16px;
    left: 43px;
  }
}

@media screen and (max-width: 1499px) {
  .id_arrow .fa-sort-asc:before {
    content: "\f0de";
    color: #219FD5;
    padding-left: 7px;
    position: absolute;
    top: 28px;
    left: 43px;
  }

  .id_arrow .fa-sort-desc:before {
    content: "\f0dd";
    position: absolute;
    top: 28px;
    left: 43px;
    padding-left: 7px;
    color: #219FD5;
  }

}



.max-height-screen {
  max-height: calc(100vh - 380px);
}

.trim_text {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
}

.tooltip {
  display: inline-block;
  position: relative;
  text-align: left;
}

.tooltip .top {
  width: 250px;
  top: 50%;
  left: 100%;
  margin-left: 20px;
  transform: translate(0, -50%);
  padding: 5px 10px;
  color: #444444;
  background-color: #EEEEEE;
  font-weight: normal;
  font-size: 14px;
  border-radius: 5px;
  position: absolute;
  z-index: 99999999;
  box-sizing: border-box;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
  display: none;
  white-space: normal;
}

.tooltip:hover .top {
  display: block;
}

.tooltip .top i {
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -12px;
  width: 12px;
  height: 24px;
  overflow: hidden;
}

.tooltip .top i::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  left: 0;
  top: 50%;
  transform: translate(50%, -50%) rotate(-45deg);
  background-color: #EEEEEE;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}

.top.deprecated_text {
  width: 200px;
  margin-left: 10px;
}

.tooltip.deprecated_block {
  cursor: help;
}
</style>
